import { render } from "./BankAccount.vue?vue&type=template&id=9764eac2&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"

import "./BankAccount.vue?vue&type=style&index=0&id=9764eac2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9764eac2"]])

export default __exports__